import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { CardPayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: CardPayload) =>
    $actions.billing.attachCard(dispatch, payload),
  );
};
